import type { JSX } from 'react'

import { useMemo } from 'react'
import { useCurrentCard } from 'blocks/Grid/hooks'
import { Skeleton } from 'blocks/Skeletons'
import { RowSkeletonItem } from 'blocks/Skeletons/components/RowSkeleton/RowSkeleton.styled'
import { CardsInRow } from 'containers/RowContainer'
import { useClientWidth } from 'utils/hooks'
import { FIXED_INDENTS, LAYOUT } from 'vars/index'
import {
  GridSkeletonBundleTitleSC,
  GridSkeletonInnerSC,
  GridSkeletonSC,
  GridSkeletonTitleSC,
} from '../components/GridSkeleton/GridSkeleton.styled'

export interface IBundlePageSkeleton {
  cardsAspectRatio?: number
  paddings?: (LAYOUT | FIXED_INDENTS)[]
  rowGap?: FIXED_INDENTS
  totalRows?: number
  tvChannelCard?: boolean
  cardsInRow: CardsInRow
}

export const BundlePageSkeleton = ({
  cardsAspectRatio = 1.48,
  paddings = [
    FIXED_INDENTS.INDENT_70,
    LAYOUT.HorizontalPaddings,
    FIXED_INDENTS.INDENT_0,
  ],
  rowGap = FIXED_INDENTS.INDENT_40,
  totalRows = 6,
  tvChannelCard = false,
  cardsInRow = CardsInRow.Horizontal_4,
}: IBundlePageSkeleton): JSX.Element => {
  const clientWidth = useClientWidth()
  const cardCount = useMemo(() => +cardsInRow.split('_')[1], [cardsInRow])
  const rowDirection = useMemo(() => cardsInRow?.charAt(0), [cardsInRow])
  const countCard = useCurrentCard({
    cardsInRow: cardCount,
    rowDirection,
    clientWidth,
    tvChannelCard,
  })

  return (
    <Skeleton>
      <GridSkeletonInnerSC paddings={paddings}>
        <GridSkeletonBundleTitleSC>
          <GridSkeletonTitleSC />
          <GridSkeletonTitleSC />
        </GridSkeletonBundleTitleSC>
        <GridSkeletonSC
          rowGap={rowGap}
          cardCount={countCard}
          cardsAspectRatio={cardsAspectRatio}
          totalRows={totalRows}
        >
          {new Array(totalRows * countCard).fill(' ').map((_, index) => (
            <RowSkeletonItem key={`${Math.random()}_${index}`} />
          ))}
        </GridSkeletonSC>
      </GridSkeletonInnerSC>
    </Skeleton>
  )
}
